<template>
  <div class="modal-body">
    <ul class="list-group">
      <!-- Loop through topics -->
      <li
        v-for="(topic, i) in student?.topics"
        :key="i"
        class="list-group-item d-flex justify-content-between align-items-center bg-dark text-white border-pink"
      >
        <div>
          <strong>{{ topic.title }}</strong>
          <small v-if="topic.valid_until" class="ms-2 text-muted">
            (Valid until {{ topic.valid_until }})
          </small>
        </div>

        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            :id="'switch-' + topic.id"
            v-model="topic.active"
            @change="toggleTopic(topic)"
          />
          <label class="form-check-label" :for="'switch-' + topic.id">{{
            topic.active ? "Active" : "Inactive"
          }}</label>
        </div>
      </li>

      <!-- No topics -->
      <li
        v-if="!student?.topics?.length"
        class="list-group-item bg-dark text-white border-pink"
      >
        No topics enrolled.
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ViewEnrollmentTopics",
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async toggleTopic(topic) {
      try {
        // Update status on backend
        await axios.post(`/a-toggle-topic/${topic.id}`, {
          status: topic.active ? "active" : "inactive",
        });
      } catch (err) {
        console.error(err);
        alert("Failed to update topic status");
        // Revert switch if API fails
        topic.active = !topic.active;
      }
    },
  },
};
</script>

<style scoped>
.list-group-item {
  margin-bottom: 5px;
}

/* Optional styling for switch */
.form-check-input:checked {
  background-color: #ff00cc;
  border-color: #ff00cc;
}

.form-check-label {
  margin-left: 8px;
  font-weight: 500;
}
</style>
